import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { Link, useHistory, useParams } from 'react-router-dom'
import { GetSamplePostResponse, getSamplePostV1 } from 'apis/door/PostV1'
import loadingModules from 'modules/loading'
import { useDispatch } from 'react-redux'
import BreadCrumbs, { BreadCrumb } from 'components/common/BreadCrumbs'
import SamplePostDetail from 'components/door/post/SamplePostDetail'
import SamplePostOwnerDetail from 'components/door/post/SamplePostOwnerDetail'
import { isAxiosError } from 'apis/base'

export default function SamplePost() {
  let { door_id, id } = useParams<{
    door_id: string
    id: string
  }>()
  const [samplePost, setSamplePost] = useState<
    GetSamplePostResponse | undefined
  >(undefined)
  const history = useHistory()

  const [breadCrumbs, setBreadCrumbs] = useState<Array<BreadCrumb>>([])
  const [mediaClass, setMediaClass] = useState<string[]>([])
  const scrollStartPoint = useRef<HTMLDivElement>(null)

  const dispatch = useDispatch()
  useEffect(() => {
    const fetch = async () => {
      try {
        dispatch(loadingModules.actions.start())
        const response = await getSamplePostV1(door_id, id)
        const samplePost = response.data
        setSamplePost(samplePost)
        setBreadCrumbs([
          { to: `/door/${door_id}`, name: samplePost.door.title },
          { to: '', name: response.data.title }
        ])

        const arr = ['mediaImagesWrapper', '-postDetail']
        const total = samplePost.attached_files.images.length
        if (total >= 5) {
          arr.push(`images-more`)
        } else {
          arr.push(`images-${total}`)
        }
        setMediaClass(arr)
      } catch (err) {
        if (isAxiosError(err) && err.response?.status === 404) {
          history.push(`/door/${door_id}`)
        }
      } finally {
        dispatch(loadingModules.actions.stop())
      }
    }
    fetch()
  }, [id])

  const Card = () => {
    return samplePost == null ? (
      <> </>
    ) : (
      <InvitationCard>
          {samplePost?.door.is_owned || samplePost?.door.is_staff || samplePost?.room.is_subscribing ? (
          <>
            <InvitationCardDescription>
              続きはトークルームでご覧ください
            </InvitationCardDescription>
            <EnterTalkRoomButton
              to={`/room/${door_id}/${samplePost.room_id}/${samplePost.dynamo_id}`}
            >
              トークルームへ
            </EnterTalkRoomButton>
          </>
        ) : (
          <>
            <InvitationCardDescription>
              続きを読むにはプランへの参加が必要です
            </InvitationCardDescription>
            <JoinConfirmButton
              to={`/door/${door_id}/plans?room=${samplePost?.room.id}`}
            >
              参加する
            </JoinConfirmButton>
          </>
        )}
      </InvitationCard>
    )
  }

  // @ts-ignore
  return (
    <ContentWrapDiv className="profile" ref={scrollStartPoint}>
      <div className="layout-col2">
        <div className="layout-col2-left">
          <StyledBreadCrumbs breadcrumbsList={breadCrumbs} />
          <SamplePostDetail samplePost={samplePost} mediaClass={mediaClass} />
          {Card()}
        </div>
        <SamplePostOwnerDetail
          ownerName={samplePost ? samplePost?.owner.name : ''}
          ownerIcon={samplePost ? samplePost?.owner.icon : ''}
          description={samplePost ? samplePost?.door.description : ''}
          doorId={samplePost ? samplePost?.door.id : ''}
          children={
            <OtherSamplesListWrap>
              <OtherSamplesListTitle>投稿サンプル一覧</OtherSamplesListTitle>
              <OtherSamplesList>
                {samplePost &&
                  samplePost.other_sample_posts.map((post) => {
                    return (
                      <li>
                        <Link to={`/door/${door_id}/samples/${post.id}`}>
                          {post.title}
                        </Link>
                      </li>
                    )
                  })}
                <OtherSamplesPrev>
                  <Link to={`/door/${door_id}?tab=samples`}>一覧に戻る</Link>
                </OtherSamplesPrev>
              </OtherSamplesList>
            </OtherSamplesListWrap>
          }
        />
      </div>
    </ContentWrapDiv>
  )
}


const StyledBreadCrumbs = styled(BreadCrumbs)`
  @media (max-width: 640px) {
    margin-top: 16px;
  }
`
const InvitationCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 732px;
  width: 100%;
  margin: 0 auto;
  padding: 32px 40px;
  background: #ffffff;
  box-shadow: 0px 4px 24px #475b6152;
  border-radius: 16px;
`
const InvitationCardDescription = styled.p`
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin-bottom: 24px;
`
const EnterTalkRoomButton = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 308px;
  height: 48px;
  background: #45b5f5;
  border-radius: 24px;
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  &:hover {
    opacity: 0.8;
  }
`
const JoinConfirmButton = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 308px;
  height: 48px;
  background: #fdad51;
  border-radius: 24px;
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  &:hover {
    opacity: 0.8;
  }
`

const ContentWrapDiv = styled.div`
  padding: 60px 20px 66px;
  min-height: 700px;
  @media (max-width: 640px) {
    padding: 0 16px 64px;
  }
  .layout-col2 {
    display: flex;
    justify-content: space-between;
    max-width: 1280px;
    margin: auto;
    gap: 40px;
    flex-wrap: wrap;
    @media (max-width: 768px) {
      gap: 32px;
    }
  }

  .layout-col2-left {
    width: 69%;
    width: calc(100% - 396px);
    @media (max-width: 1280px) {
      width: calc(100% - 320px);
    }
    @media (max-width: 768px) {
      width: 100%;
    }
    .breadcrumbs .inner {
      margin: 0;
    }
  }
`

const OtherSamplesListWrap = styled.div`
  margin-top: 48px;
`
const OtherSamplesListTitle = styled.h3`
  color: #333333;
  font-size: 16px;
  font-weight: bold;
  border-bottom: 1px solid #ddd;
  padding-bottom: 8px;
  margin-bottom: 16px;
`
const OtherSamplesList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 12px;
  a {
    color: #333333;
    &:hover {
      opacity: 0.9;
    }
  }
`
const OtherSamplesPrev = styled.li`
  text-align: right;
  a {
    color: #45b5f5;
  }
`
